var app = {
	header: {
		closeButton: "Затвори",
		copyrightLabel: "Авторско право",
		helpLabel: "Помощ",
		legalNoticeLabel: "Юридическо съобщение",
		logoutButton: "Изход",
		menuLabel: "Меню",
		noUserDataLabel: "Няма налични потребителски данни",
		notificationsLabel: "Известия",
		privacyPolicyLabel: "Политика за поверителност",
		serviceAppLabel: "Приложение за услуги",
		settingsLabel: "Настройки",
		shopLabel: "Магазин",
		smartFactorySuiteLabel: "Смарт-фабрика пакет",
		userLabel: "Профил",
		userProfileLinkText: "Профил на потребителя"
	}
};
var contentLoadingError = "Съдържанието не може да бъде заредено";
var dashboard = {
	cancel: {
		button: "Отказ"
	},
	edit: {
		button: "Редактиране"
	},
	reset: {
		button: "Нулиране"
	},
	save: {
		button: "Запази"
	},
	share: {
		button: "Сподели"
	}
};
var filter = {
	clear: "Нулиране на филтрите",
	clearAll: "Нулиране на всички филтри"
};
var locationMap = {
	locationLink: {
		label: "Отиди на място"
	}
};
var machineDiscontinuation = {
	linkText: "Научете повече"
};
var notifications = {
	button: {
		loadMore: "Зареди още"
	},
	date: {
		lastMonth: "Миналия месец",
		lastWeek: "Миналата седмица",
		older: "По-стари",
		thisMonth: "Този месец",
		thisWeek: "Тази седмица",
		today: "Днес",
		yesterday: "Вчера"
	},
	error: {
		general: "В момента известията не могат да бъдат показани. Моля, опитайте по-късно.",
		unauthorized: "Моля, влезте, за да видите известията"
	},
	info: {
		activateSettings: "За да получавате известия, моля активирайте ги в настройките",
		noNotification: "В момента нямате съобщения."
	},
	title: "Известия"
};
var results = {
	counter: {
		label: "резултата"
	}
};
var scrollToTop = {
	label: "Превърти най-горе"
};
var slider = {
	nextButton: {
		label: "Следващ слайд"
	},
	paginationBullet: {
		label: "Слайд"
	},
	prevButton: {
		label: "Предишен слайд"
	}
};
var sorting = {
	ascending: "Възходящо",
	descending: "Низходящо"
};
var userAccount = {
	address: {
		label: "Пощенски адрес"
	},
	email: {
		label: "Имейл"
	},
	language: {
		label: "Език",
		locale: "Локал",
		select: "Изберете език",
		settings: "Настройки на езика"
	},
	loggedOut: {
		message: "Не сте влезли в системата"
	},
	login: {
		button: "Вход"
	},
	name: {
		label: "Име"
	},
	phone: {
		label: "Телефон"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Филтрирай машини",
			label: "Машини",
			option: {
				all: "Всички машини"
			},
			select: "Избери машина"
		},
		period: {
			label: "Период",
			option: {
				currentMonth: "Този месец",
				currentWeek: "Тази седмица",
				lastMonth: "Миналият месец",
				lastWeek: "Миналата седмица",
				today: "Днес",
				yesterday: "Вчера"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Моите widget-и"
	},
	noDescriptionAvailable: "Няма налично описание.",
	widget: {
		SampleMyMachines: {
			title: "Моите машини"
		},
		SampleMyServiceCalls: {
			title: "Обаждания за сервиз"
		},
		SampleMyTrackingList: {
			title: "Списък за проследяване"
		},
		SampleMyUserAccount: {
			title: "Моят профил"
		},
		SampleOperationalStatesChart: {
			title: "Оперативни състояния"
		},
		SampleWidgetFilter: {
			title: "Настройки на филтъра"
		},
		SampleWorkloadBalanceChart: {
			title: "Баланс на работната натовареност"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
